import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Table from '@material-ui/core/Table/index';
import TableBody from '@material-ui/core/TableBody/index';
import TableCell from '@material-ui/core/TableCell/index';
import TableHead from '@material-ui/core/TableHead/index';
import TableRow from '@material-ui/core/TableRow/index';
import Paper from '@material-ui/core/Paper/index';

import IconButton from "@material-ui/core/IconButton/index";
import Zoom from "@material-ui/core/Zoom/index";
import Tooltip from "@material-ui/core/Tooltip/index";
import DeleteOutlined from '@material-ui/icons/DeleteOutlined';
import {ReactLocalStorageService} from "../../../../settings/ReactLocalStorageService/ReactLocalStorageService";
import {PopupService} from "../../../../settings/PoPup/PoPup";
import {RecordatoriosService} from "../../../../services/RecordatoriosService/RecordatoriosService";
import ModalRecordatorios from "./ModalRecordatorios";
import {CONFIG} from "../../../../settings/Config/Config";
import Typography from "@material-ui/core/Typography";
import {FiberManualRecord} from "@material-ui/icons";

class ListaTabla extends Component {
	
	Usr = {};
	
	constructor() {
		super();
		this.Usr = ReactLocalStorageService.get('Usr') || {};
	}
	
	eliminar = (item) => {
		let msg = `¿Deseas eliminar el recordatorio ${item.recordatorio}?`;
		PopupService.Confirm(['Cancelar', 'Eliminar'], 'warning', CONFIG.titulo_alert_confirm, msg).then((r) => {
			if (r.button === 'Eliminar') {
				RecordatoriosService.Eliminar(item.id_recordatorio).then((response) => {
					this.props.showSnackBars('success', response.mensaje);
					this.props.RefreshList();
				}).catch((error) => {
					this.props.showSnackBars('error', error.mensaje);
				});
			}
		});
	};
	
	activo = (item, activo) => {
		let msg = `¿Deseas ${activo ? 'activar':'desactivar'} el recordatorio ${item.recordatorio}?`;
		let txtbtn = activo ? 'Activar':'Desactivar';
		PopupService.Confirm(['Cancelar', txtbtn], 'warning', CONFIG.titulo_alert_confirm, msg).then((r) => {
			if (r.button === 'Activar' || r.button === 'Desactivar') {
				RecordatoriosService.Activo(item.id_recordatorio, activo).then((response) => {
					this.props.showSnackBars('success', response.mensaje);
					this.props.RefreshList();
				}).catch((error) => {
					this.props.showSnackBars('error', error.mensaje);
				});
			}
		});
	};
	
	render() {
		
		const {lista} = this.props;
		
		return (
			<Paper style={{overflowX: "auto"}}>
				<Table className={'desing-acresco'}>
					<TableHead>
						<TableRow>
							<TableCell component="th" align={'center'} className={'w-40-px padding-20-L padding-20-R'}>
								ID
							</TableCell>
							<TableCell component="th" align={'left'}>Descripción</TableCell>
							<TableCell component="th" align={'left'} className={'w-210-px'}>Usuarios</TableCell>
							<TableCell component="th" align={'left'}>Recordatorio</TableCell>
							<TableCell component="th" align={'left'}>Fecha/Hora Inicio</TableCell>
							<TableCell component="th" align={'left'}>Fecha/Hora Fin</TableCell>
							<TableCell component="th" align={'left'}>Frecuencia</TableCell>
							<TableCell component="th" align={'center'}>Activo</TableCell>
							<TableCell component="th" align={'center'} className={'w-150-px'}>Acciones</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{lista.map((item, key) => (
							<TableRow key={key}>
								<TableCell align={'center'} className={'padding-20-L padding-20-R'}>
									{item.id_recordatorio}
								</TableCell>
								<TableCell align={'left'}>{item.recordatorio}</TableCell>
								<TableCell align={'left'}>
									{item.asignados.map((item2, key2) => (
										<div key={key2} className={'vertical-inline margin-3-T margin-3-B w-100'}>
											<div className={'v-center w-30-px h-30-px b-r-100 bg-img-contain-x-center-y-center'}
											     style={{backgroundImage: `url(${item2.foto ? CONFIG.src + item2.foto : CONFIG.foto_default})`}}>
											</div>
											<Typography variant={'h5'} className={'v-center padding-10-L margin-0 text-black px-13'}>
												{item2.nombre_completo}
											</Typography>
										</div>
									))}
								</TableCell>
								<TableCell align={'left'}>{item.cat_recordatorio}</TableCell>
								<TableCell align={'left'}>{item.fecha_notificacion}</TableCell>
								<TableCell align={'left'}>{item.fecha_fin_notificacion?item.fecha_fin_notificacion:'Sin registrar'}</TableCell>
								<TableCell align={'left'}>{item.frecuencia_notificacion}</TableCell>
								<TableCell align={'center'}>
									{item.activo === 1 ? (
										<div style={{
											width: "50px",
											color: "white",
											borderRadius: "3px",
											padding: "2px 10px",
											background: "darkgreen",
											display: "inline-grid",
										}}>Activo</div>
									) : (
										<div style={{
											width: "50px",
											color: "white",
											borderRadius: "3px",
											padding: "2px 10px",
											background: "#901C30",
											display: "inline-grid",
										}}>Inactivo</div>
									)}
								</TableCell>
								<TableCell align={'center'} className={'padding-5-L padding-5-R'}>
									<div className={'w-auto vertical-inline'}>
										<div className={'v-center'}>
											<Tooltip TransitionComponent={Zoom} placement={"top"} title="Desactivar">
												<IconButton aria-label="Desactivar"
												            onClick={() => this.activo(item, 0)}>
													<FiberManualRecord style={{color: '#901C30'}}/>
												</IconButton>
											</Tooltip>
										</div>
										
										<div className={'v-center'}>
											<Tooltip TransitionComponent={Zoom} placement={"top"} title="Activar">
												<IconButton aria-label="Activar"
												            onClick={() => this.activo(item, 1)}>
													<FiberManualRecord style={{color: '#009018'}}/>
												</IconButton>
											</Tooltip>
										</div>
										
										<div className={'v-center'}>
											<ModalRecordatorios
												tipo={'edit'}
												item={item}
												RefreshList={this.props.RefreshList}
												showSnackBars={this.props.showSnackBars}
											/>
										</div>
										<div className={'v-center'}>
											<ModalRecordatorios
												tipo={'view'}
												item={item}
												RefreshList={this.props.RefreshList}
												showSnackBars={this.props.showSnackBars}
											/>
										</div>
									</div>
								</TableCell>
							</TableRow>
						))}
					</TableBody>
				</Table>
			</Paper>
		)
	}
}

ListaTabla.propTypes = {
	lista: PropTypes.array.isRequired,
	RefreshList: PropTypes.func.isRequired,
	showSnackBars: PropTypes.func.isRequired,
};

export default ListaTabla;
